import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import type { CSSProperties } from 'vue/types/jsx'

type Edge = 'top' | 'bottom' | 'start' | 'end'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzDropIndicatorLine',
  props: {
    edge: null,
    gap: { default: 0 },
    darkMode: { type: [Boolean, String], default: 'auto' }
  },
  setup(__props: any) {

const props = __props as { edge: Edge, gap: number, darkMode: boolean | 'auto' };

const EDGE_TO_POSITIONAL_PROPERTY_MAP: Record<Edge, keyof CSSProperties> = {
  top: 'top',
  bottom: 'bottom',
  start: 'inset-inline-start',
  end: 'inset-inline-end',
}

const LINE_SIZE = 2 // px



const isVertical = computed(() => props.edge === 'start' || props.edge === 'end')

const styles = computed<CSSProperties>(() => {
  const val = -(props.gap + LINE_SIZE) / 2
  const prop = EDGE_TO_POSITIONAL_PROPERTY_MAP[props.edge]
  return { [prop]: `${val}px` }
})

return { __sfc: true,EDGE_TO_POSITIONAL_PROPERTY_MAP, LINE_SIZE, props, isVertical, styles }
}

})